<div class="tutorial-container">
  <!-- Encabezado del Tutorial -->
  <div class="tutorial-header">
    <h1>Guía de nueva version</h1>
    <p>Guía completa e interactiva</p>
    <label style="align-items: left;">
      <input type="checkbox"#CheckSaltearIntro   (change)="onCheckboxChange($event)">
      Por favor destilde esta opción luego de haber leído esta guia con los cambios de la versión
    </label>
  </div>

  <div class="tutorial-content">
    <!-- Panel de Navegación -->
    <div class="navigation-panel">
      <button *ngFor="let item of tutorialItems | keyvalue; trackBy: trackByFn"
              (click)="selectItem(item.key)"
              [class.active]="selectedItem === item.key"
              class="nav-item">
        <div class="nav-item-header">
          <fa-icon [icon]="item.value.icon"></fa-icon>
          <span>{{item.value.title}}</span>
        </div>
        <p>{{item.value.description}}</p>
      </button>
    </div>

    <!-- Área de Contenido -->
    <div class="content-area" *ngIf="tutorialItems[selectedItem]">
      <div class="content-card">
        <h2>
          <fa-icon [icon]="tutorialItems[selectedItem].icon"></fa-icon>
          {{tutorialItems[selectedItem].title}}
        </h2>

        <!-- Área Visual -->
        <div class="visual-area" [ngSwitch]="tutorialItems[selectedItem].visual">
          <!-- Interface Principal -->
          <div *ngSwitchCase="'interface'" class="interface-demo">
            <div class="counter-group">
              <div class="counter">0 SELECCIONADOS</div>
              <div class="counter">48 TOTALES</div>
            </div>
            <button class="download-btn">
              <fa-icon [icon]="icons.download"></fa-icon>
              Descargar
            </button>
            <div class="checkbox-group">
              <input type="checkbox" checked disabled>
              <span>Certificados</span>
            </div>
          </div>

          <!-- Filtros -->
          <div *ngSwitchCase="'filtros'" class="filters-demo">
            <div class="filter-headers">
              <div class="filter-header" *ngFor="let col of ['Factura', 'Lugar', 'Fecha', 'Ident.', 'Análisis', 'Pago']">
                <div class="header-content">
                  <span>{{col}}</span>
                  <div class="header-icons">
                    <fa-icon [icon]="icons.arrows"></fa-icon>
                    <fa-icon [icon]="icons.filter"></fa-icon>
                  </div>
                </div>
                <div class="search-box">
                  <fa-icon [icon]="icons.search"></fa-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Tipo de Búsqueda -->
          <div *ngSwitchCase="'busqueda'" class="search-type-demo">
            <select class="search-select">
              <option>Descarga Pendientes</option>
              <option>Todos</option>
            </select>

          </div>

          <!-- Acciones Principales -->
          <div *ngSwitchCase="'acciones'" class="actions-demo">
            <div class="buttons-group">
              <button class="action-btn">
                <fa-icon [icon]="icons.sync"></fa-icon>
                Datos
              </button>
              <button class="action-btn">
                <fa-icon [icon]="icons.table"></fa-icon>
                Grilla
              </button>
            </div>
            <!-- <div class="actions-info mt-4">
              <div class="info-card">
                <h4>¿Cuándo usar?</h4>
                <ul>
                  <li>Datos: Para actualizar información desde el servidor</li>
                  <li>Grilla: Para restaurar la vista predeterminada</li>
                </ul>
              </div>
            </div> -->
          </div>

          <!-- Herramientas de Personalización -->
          <div *ngSwitchCase="'herramientas'" class="tools-demo">
            <div class="tools-buttons">
              <button class="tool-btn" title="Administrar columnas">
                <fa-icon [icon]="icons.columns"></fa-icon>
              </button>
              <button class="tool-btn" title="Exportar a Excel">
                <fa-icon [icon]="icons.excel"></fa-icon>
              </button>
            </div>
            <!-- <div class="tools-info mt-4">
              <div class="info-card">
                <h4>Funcionalidades disponibles</h4>
                <ul>
                  <li>Gestión de columnas visibles</li>
                  <li>Exportación de datos a Excel</li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>

        <!-- Subsecciones -->
        <div class="subsections" *ngIf="tutorialItems[selectedItem].subsections">
          <div class="subsections-grid">
            <button *ngFor="let subsection of tutorialItems[selectedItem].subsections; let i = index"
                    (click)="selectSubsection(i)"
                    [class.active]="selectedSubsection === i"
                    class="subsection-btn">
              <div class="subsection-header">
                <fa-icon [icon]="subsection.icon"></fa-icon>
                <span>{{subsection.title}}</span>
              </div>
              <p>{{subsection.description}}</p>
            </button>
          </div>

          <!-- Detalles de subsección seleccionada -->
          <div class="subsection-details" *ngIf="selectedSubsection !== null">
            <h3>
              <fa-icon [icon]="tutorialItems[selectedItem].subsections[selectedSubsection].icon"></fa-icon>
              {{tutorialItems[selectedItem].subsections[selectedSubsection].title}}
            </h3>
            <ul>
              <li *ngFor="let detail of tutorialItems[selectedItem].subsections[selectedSubsection].details">
                {{detail}}
              </li>
            </ul>
          </div>
        </div>

        <!-- Detalles Generales -->
        <div class="details-section">
          <h3>Detalles</h3>
          <ul>
            <li *ngFor="let detail of tutorialItems[selectedItem].details">
              {{detail}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>